import axios from "axios";
import { AssetManagementService_URL, SystemService_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../Logout/actions";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// Save AssetType

export const SaveDataSubActions = {
  SAVE_DATA_SUB: "SAVE_DATA_SUB",
  SAVE_DATA_SUB_STATUS: "SAVE_DATA_SUB_STATUS",
  SAVE_DATA_SUB_SUCCESS: "SAVE_DATA_SUB_SUCCESS",
  SAVE_DATA_SUB_FAILURE: "SAVE_DATA_SUB_FAILURE",
  LOGOUT: "LOGOUT",
};
export function logout() {
  return {
    type: SaveDataSubActions.LOGOUT,
    payload: "Session Expired. Please Login Again",
  };
}

export function SaveDataSubRequest() {
  return {
    type: SaveDataSubActions.SAVE_DATA_SUB,
    isPosting: true,
  };
}

export function SaveDataSubSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveDataSubActions.SAVE_DATA_SUB_SUCCESS,
      payload: props,
    });
  };
}

export function SaveDataSubFailure(error) {
  return {
    type: SaveDataSubActions.SAVE_DATA_SUB_FAILURE,
    payload: error,
  };
}

export function SaveDataSubError(error) {
  return {
    type: SaveDataSubActions.SAVE_DATA_SUB_FAILURE,
    payload: error,
  };
}

export function saveDataSub(props) {
  var value = {
    id: props.dataSubId || 0,
    name: props.dataSubName,
    description: props.dataSubDesc,
  };

  return (dispatch) =>
    axios({
      method: "post",
      data: value,
      url: `${SystemService_URL}/Apc_Persist/Amc_14/saveDataSubject`,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(SaveDataSubRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(SaveDataSubSuccess(response));
          return response;
        } else if (response.status >= 401 && response.status < 500) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SaveDataSubError(error));
          // throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          return err;

          // switch (err.response.status) {
          //   case 400:
          //     map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //     map.forEach(ele => (err = ele));

          //     dispatch(SaveRoleError(err));
          //     break;

          //     map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //     map.forEach(ele => (err = ele));

          //     dispatch(SaveRoleError(err));
          //     break;
          //   case 406:
          //     map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //     map.forEach(ele => (err = ele));

          //     dispatch(SaveRoleError(err));
          //     break;
          //   case 500:
          //     dispatch(SaveRoleError("Server Error"));
          //     break;
          //   default:
          //     dispatch(SaveRoleError("Unknown Error"));
          //     break;
          // }
        } else {
          //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

// clear  details
export const ClearFormDetailsActions = {
  CLEAR_FORM_DETAILS: "CLEAR_FORM_DETAILS",
};

export function clearFormData() {
  return (dispatch) => dispatch(clearFormDetails());
}

export function clearFormDetails() {
  return {
    type: ClearFormDetailsActions.CLEAR_FORM_DETAILS,
  };
}

// get  details by id

///////GET LOION BY ID

export const GetDataSubDetailsActions = {
  FETCH_DATA_SUB_DETAILS: "FETCH_DATA_SUB_DETAILS",
  FETCH_DATA_SUB_DETAILS_STATUS: "FETCH_DATA_SUB_DETAILS_STATUS",
  FETCH_DATA_SUB_DETAILS_FULFILLED: "FETCH_DATA_SUB_DETAILS_FULFILLED",
  FETCH_DATA_SUB_DETAILS_REJECTED: "FETCH_DATA_SUB_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getDataSubDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url:
        `${SystemService_URL}/Apc_View/Amc_14/findDataSubjectById?id=` +
        params.dataSubId,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getDataSubDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getDataSubDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getDataSubDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getDataSubDetailsError(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getDataSubDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getDataSubDetailsError(err));
              break;
            case 500:
              dispatch(getDataSubDetailsError("Server Error"));
              break;
            default:
              dispatch(getDataSubDetailsError("Unknown Error"));
              break;
          }
        } else {
          //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getDataSubDetailsRequest() {
  return {
    type: GetDataSubDetailsActions.FETCH_DATA_SUB_DETAILS,
    isPosting: true,
  };
}
export function getDataSubDetailsError(error) {
  return {
    type: GetDataSubDetailsActions.FETCH_DATA_SUB_DETAILS_REJECTED,
    payload: error,
  };
}

export function getDataSubDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetDataSubDetailsActions.FETCH_DATA_SUB_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getDataSubDetailsStatus() {
  return (dispatch) => dispatch(getDataSubDetailsStatusRequest());
}
export function getDataSubDetailsStatusRequest() {
  return {
    type: GetDataSubDetailsActions.FETCH_DATA_SUB_DETAILS_STATUS,
  };
}

export function setDetailsError() {
  return (dispatch) => dispatch(getDataSubDetailsErrorRequest());
}
export function getDataSubDetailsErrorRequest() {
  return {
    type: GetDataSubDetailsActions.SET_EDIT_ERROR,
  };
}

//////////////////////////////////////////////////////////////////////////////////////////
export const UploadexcelActions = {
  CREATE_UPLOAD_EXCEL: "CREATE_UPLOAD_EXCEL",
  CREATE_UPLOAD_EXCEL_SUCCESS: "CREATE_UPLOAD_EXCEL_SUCCESS",
  CREATE_UPLOAD_EXCEL_FAILURE: "CREATE_UPLOAD_EXCEL_FAILURE",
};

export function UploadexcelRequest() {
  return {
    type: UploadexcelActions.CREATE_UPLOAD_EXCEL,
    isPosting: true,
  };
}

export function UploadexcelSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: UploadexcelActions.CREATE_UPLOAD_EXCEL_SUCCESS,
      payload: props,
    });
  };
}

export function UploadexcelFailure(error) {
  return {
    type: UploadexcelActions.CREATE_UPLOAD_EXCEL_FAILURE,
    payload: error,
  };
}

export function UploadExcel(props) {
  let data = new FormData();
  data.append("hostingTypes", props.Excel);

  return (dispatch) =>
    axios({
      method: "post",
      data: data,
      url: `${AssetManagementService_URL}/bulkUploadExcel`,
      headers: {
        "Content-Type": "appliion/json",
        Authorization: "Bearer " + props.access_token,
        transactionId: "1",
      },
    })
      .then((response) => {
        dispatch(UploadexcelRequest());
        if (response.status === 200) {
          dispatch(UploadexcelSuccess(response));
        } else {
          const error = new Error(response.statusText);
          dispatch(UploadexcelFailure(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(UploadexcelFailure(err));
              break;
            case 401:
              dispatch(clearLogoutData());
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(UploadexcelFailure(err));
              break;
            case 500:
              dispatch(UploadexcelFailure("Server Error"));
              break;
            default:
              dispatch(UploadexcelFailure("Unknown Error"));
              break;
          }
        } else {
          dispatch(UploadexcelFailure("Internal Server Error"));
          dispatch(clearLogoutData());
        }
      });
}

export const GetActiveDataSubjectActions = {
  FETCH_ACTIVE_DATA_SUB: "FETCH_ACTIVE_DATA_SUB",
  FETCH_ACTIVE_DATA_SUB_STATUS: "FETCH_ACTIVE_DATA_SUB_STATUS",
  FETCH_ACTIVE_DATA_SUB_FULFILLED: "FETCH_ACTIVE_DATA_SUB_FULFILLED",
  FETCH_ACTIVE_DATA_SUB_REJECTED: "FETCH_ACTIVE_DATA_SUB_REJECTED",
};
export function getActiveDataSubjectMaster(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${SystemService_URL}/Apc_View/Amc_14/getAllDataSubjectPagination?length=0&sortOrder=desc&sortField=id&booleanfield=true`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveDataSubjectListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveDataSubjectListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveDataSubjectListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          // switch (err.response.status) {
          //   case 400:
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          return err;
          // dispatch(getActiveDataSubjectListError(err));
          //     break;

          //     map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //     map.forEach(ele => (err = ele));

          //     dispatch(getActiveDataSubjectListError(err));
          //     break;
          //   case 406:
          //     map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          //     map.forEach(ele => (err = ele));

          //     dispatch(getActiveDataSubjectListError(err));
          //     break;
          //   case 500:
          //     dispatch(getActiveDataSubjectListError("Server Error"));
          //     break;
          //   default:
          //     dispatch(getActiveDataSubjectListError("Unknown Error"));
          //     break;
          // }
        } else {
          //dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveDataSubjectListRequest() {
  return {
    type: GetActiveDataSubjectActions.FETCH_ACTIVE_DATA_SUB,
    isPosting: true,
  };
}
export function getActiveDataSubjectListError(error) {
  return {
    type: GetActiveDataSubjectActions.FETCH_ACTIVE_DATA_SUB_REJECTED,
    payload: error,
  };
}

export function getActiveDataSubjectListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveDataSubjectActions.FETCH_ACTIVE_DATA_SUB_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveDataSubjectListStatus() {
  return (dispatch) => dispatch(getActiveDataSubjectListStatusRequest());
}
export function getActiveDataSubjectListStatusRequest() {
  return {
    type: GetActiveDataSubjectActions.FETCH_ACTIVE_DATA_SUB_STATUS,
  };
}
